// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3astM","alertIcon":"ConfirmModal_alertIcon__1oePT"};